import React from 'react';
import { Container, Typography } from '@mui/material';

function Home() {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Welkom bij de Collectanten App
      </Typography>
      <Typography variant="body1">
        Gebruik de navigatie onderaan om collectanten te uploaden of te bekijken.
      </Typography>
    </Container>
  );
}

export default Home;